import type { FooterSection } from '@/data/types';
import footerData from '@/data/footer.json';

export function useFooterData() {
  return {
    footerData: footerData as FooterSection
  };
}